import { Component, OnInit, OnDestroy, NgZone, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { reduce, retry } from 'rxjs/operators';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import * as moment from 'moment-timezone';
declare let google: any

@Component({
  selector: 'app-device-detail-new',
  templateUrl: './device-detail-new.component.html',
  styleUrls: ['./device-detail-new.component.scss'],
  standalone: true,
  imports: [],
  providers: [ConvertDatetimePipe, ChangeUsersService]
})
export class DeviceDetailNewComponent implements OnInit {
  // @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;
  public sensorData = BaseUrlConstantsService.Sensor_Data;
  public accelsensorData = BaseUrlConstantsService.Accel_Sensor_Data;
  public Fft_List = BaseUrlConstantsService.FFT_LIST;
  public Fft_Force = BaseUrlConstantsService.FFT_FORCE;
  // public lineChartData: ChartDataSets[] = [];
  public filterType: any;
  public abc = false;
  // public lineChartDataTemp: ChartDataSets[] = [];
  // public lineChartDataOrientation: ChartDataSets[] = [];
  // public lineChartLabels: Label[] = [];
  // public lineChartLabelsOrientation: Label[] = [];
  // public lineChartLabelsTemp: Label[] = [];
  public showlineChart1: boolean;
  applicationNme: any;
  public _status: any;
  public _offlineStatus: any;
  public _lastUpdate: any;
  public _devStaus: any;
  public _orientationX: any;
  public _orientationY: any;
  public _orientationZ: any;
  public _interval: any = 3;
  public _sliderStart: any = undefined;
  public _sliderEnd: any = undefined;
  public _sliderStartTmp: any = undefined;
  public _sliderEndTmp: any = undefined;
  public loader: boolean = false;
  fday: boolean;
  fweek: boolean;
  fmonth: boolean;
  fmonths: boolean;
  public data: any = [];
  public columnNames: any = [];
  testArr = [];
  showlineChart3: any;
  errorMSG = '';


  showlineChart2: boolean;
  public lineChartLegend = true;
  public lineChartType = 'line';
  // public lineChartPlugins = [pluginAnnotations];
  public SystemName = 'MF1';
  public firstCopy = false;
  public canvasWidth = 150;
  public needleValue = 20;
  public centralLabel = '';
  public name = 'N/A';
  public bottomLabel = 'N/A';

  public breadcrumbsArray: any = [{
    page_ref: 'device-reports',
    page_title: 'Assets'
  }, {
    page_ref: '#',
    page_title: 'Trend Analysis'
  }];
  public Itemsymbol: any;
  public pageRef: any;
  public dataGadge: any;
  public meterShownResult: any = [];
  public tempratueResults: any = [];
  public orientationData: any = [];
  public rateOfTemp: any = [];
  public rateOfChange: any = [];
  public nameDevice: any;
  public deviceId: any;
  public errorStatus: any;
  public deviceStatus: any;
  public addclass: any;
  valueSelected: any;
  // tslint:disable-next-line: variable-name
  public _deviceInfo: any;
  public daterangeForm: any;
  chartBoxVisibility = false;
  chartBoxVisibility1 = false;
  public pageName: string;
  public showGraph: any = 0;
  public assetId: any;
  public _lstUpdateDate: any;
  public tabColor = '1day';
  public dayValue = 24;
  public weekValue: number;
  public monthValue: number;
  public valueType = 'min';
  public selectValue = null;
  public btnColour = '#dedede';
  public btnColor2 = '#ffffff';

  public activeTab = 'monitoring';
  public activeTabColor: string = '#dedede';
  public inactiveTabColor: string = '#ffffff';

  public siteName: any;
  public _spectralLoader: boolean = false;
  public appMacAdd: any;
  public serialNumber: any;
  public _timeOut: any;
  public trendAnalysData: any = [];

  public title;
  public type;
  public ddata: any = [];
  public options: any = {};
  public width;
  public height;
  public dataChart = [];
  company_name:string;

  constructor(
    public router: Router,
    public activeRoute: ActivatedRoute,
    public service: BackendApiService,
    private formBuilder: FormBuilder) {

    // google.charts.load('current', {'packages':['gauge']});
    // google.charts.setOnLoadCallback(this.drawChart);


    activeRoute.queryParams.subscribe(params => {
      this.deviceId = params[`deviceId`];
      this.assetId = params[`assetid`];
      this.nameDevice = params[`deviceName`];
      this.errorStatus = params[`errorStatus`];
      this.deviceStatus = params[`deviceStatus`];
      this.pageName = params[`pageRef`];
      if(this.pageName === 'AdminClientPage'){
        localStorage.setItem('company_name', params[`clientName`]);
        this.company_name = localStorage.getItem('company_name');
      }
      if (this.pageName === 'managerAssets') {
        const myObj = {
          page_ref: 'manager-client-list',
          page_title: 'manager clients'
        };
        this.breadcrumbsArray.unshift(myObj);
      }
    });
  }
  onTabClick() {

  }

  drawChart() {
    var data = google.visualization.arrayToDataTable([
      ['Label', 'Value'],
      ['Rated RPM', 3640],
      ['Actual RPM', 55]
    ]);

    var options = {
      width: 400, height: 120,
      redFrom: 90, redTo: 100,
      yellowFrom: 75, yellowTo: 90,
      minorTicks: 5
    };

    var chart = new google.visualization.Gauge(document.getElementById('chart_div_rpm'));

    chart.draw(data, options);

    setInterval(function () {
      data.setValue(0, 1, 40 + Math.round(60 * Math.random()));
      chart.draw(data, options);
    }, 13000);
    setInterval(function () {
      data.setValue(1, 1, 40 + Math.round(60 * Math.random()));
      chart.draw(data, options);
    }, 5000);
  }


  selectItem(value) {
    this._sliderStart = undefined;
    this._sliderEnd = undefined;
    this._sliderStartTmp = undefined;
    this._sliderEndTmp = undefined;
    localStorage.setItem('dataInterval', value);
    switch (value) {
      case '1day':
        this.selectValue = 24;
        this.valueType = 'min';
        this.loadAllGraphs();
        this.tabColor = value;
        break;
      case '1week':
        this.selectValue = 24;
        this.valueType = 'hour';
        this.loadAllGraphs();
        this.tabColor = value;
        break;
      case '1month':
        this.selectValue = 24;
        this.valueType = 'days';
        this.loadAllGraphs();
        this.tabColor = value;
        break;
      case '3month':
        this.selectValue = 24;
        this.valueType = 'week';
        this.loadAllGraphs();
        this.tabColor = value;
        break;
    }
  }

  loadAllGraphs() {
    if (this._timeOut !== undefined) {
      clearTimeout(this._timeOut);
    }
    let dataFreq = parseInt(localStorage.getItem('dataFrq'))
    dataFreq = ((dataFreq * 60) * 1000) / parseInt(this._interval);
    this.getSensorCharts('graph');
    // this.getSensorTempCharts('graph');
    // this.getSensorOrientationCharts('graph');
    let self = this;
    self._timeOut = setInterval(function () {
      self.getFftList()
      self.getGaugeDataByID();
      this.showlineChart1 = true;
      self.getSensorCharts('interval');
      // self.getSensorTempCharts('interval');
      // self.getSensorOrientationCharts('interval');
    }, dataFreq);
  }


  async getGaugeDataByID() {
    let response: any;
    const body = {
      deviceid: parseInt(this.deviceId),
      assetid: parseInt(this.assetId),
      // tslint:disable-next-line: radix
      datafrequency: parseInt(localStorage.getItem('dataFrq'))
    };
    this.service.getDataWithQuery(this.sensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.assetId)).then(res => {
      response = JSON.parse(JSON.stringify(res)).data;
      if (response.status === 'fail') {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === 'success') {
        this.filterType = response.body.issue.filterType;
        let _timeInterval = localStorage.getItem('dataInterval');
        if (_timeInterval === 'null') {
          if (this.filterType === 'month') {
            this.fday = true;
            this.fweek = true;
            this.fmonth = false;
            this.fmonths = false;
            this.selectItem('1month');
          } else if (this.filterType === 'months') {
            this.fday = true;
            this.fweek = true;
            this.fmonth = true;
            this.fmonths = false;
            this.selectItem('1day');
          } else if (this.filterType === 'week') {
            this.fday = true;
            this.fweek = false;
            this.fmonth = false;
            this.fmonths = false;
            this.selectItem('1week');
          } else if (this.filterType === 'day') {
            this.fday = false;
            this.fweek = false;
            this.fmonth = false;
            this.fmonths = false;
            this.selectItem('1day');
          }
        }
        if (response.body.issue.lastupdate !== this._lstUpdateDate) {
          this.rateOfChange = [];
          this.tempratueResults = [];
          this.meterShownResult = [];


          var testDateUtc = moment.utc(response.body.issue.lastupdate);
          var localDate = testDateUtc.local();
          this._lastUpdate = new ConvertDatetimePipe().convertDateTime(localDate);
          this._lstUpdateDate = this._lastUpdate
          this._status = response.body.issue.status;
          this._offlineStatus = response.body.issue.offlinestatus;

          if (this._status === 'OFFLINE') {
            this._devStaus = 'Last';
          } else {
            this._devStaus = 'Latest';
          }

          if (response.body.sensor === 'No results found') {
            this.showGraph = 0;
            this.errorMSG = response.body.sensor;
          } else {
            this.dataGadge = response.body.sensor.filter(
              (item, i, arr) => arr.findIndex(t => t.key === item.key) === i
            );
            let bottomLab;
            if (this.dataGadge.length !== 0) {
              this.showGraph = 1;

              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {
                  bottomLab = 'N/A';
                } else {
                  bottomLab = JSON.parse(this.dataGadge[mCount].value) <= 0 ? 'N/A' : (this.dataGadge[mCount].symbol === 'C' ? JSON.parse(this.dataGadge[mCount].value) + ' °' + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) + ' ' + this.dataGadge[mCount].icon);
                }

                if (parseInt(this.dataGadge[mCount].needle) === 0) {
                  this.addclass = 'big_font_chartbox';
                } else {
                  this.addclass = '';
                }
                this.Itemsymbol = this.dataGadge[mCount].symbol;


                const accelerationData = {
                  needleValue: this.dataGadge[mCount].symbol === 'm/sec²' ? JSON.parse(this.dataGadge[mCount].value) * 100 / parseFloat(this.dataGadge[mCount].rangelabel[1]) : JSON.parse(this.dataGadge[mCount].value),
                  centralLabel: JSON.parse(this.dataGadge[mCount].value) < 0 ?
                    'N/A' : JSON.parse(this.dataGadge[mCount].value),
                  outerNeedle: false,
                  canvasWidth: 150,
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: 'black',
                    needleUpdateSpeed: '',
                    arcColors: this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors : [
                      'transparent',
                      'transparent',
                      'transparent'],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel : [],
                    needleStartValue: 0
                  }
                };
                accelerationData.needleValue > 150 ? accelerationData.bottomLabel = 'N/A' : accelerationData.needleValue
                if (accelerationData.key === 'RMS_Accel_1_X_Axis') {
                  this.meterShownResult.splice(0, 0, accelerationData);
                }
                if (accelerationData.key === 'RMS_Accel_1_Y_Axis') {
                  this.meterShownResult.splice(1, 0, accelerationData);
                }
                if (accelerationData.key === 'RMS_Accel_1_Z_Axis') {
                  this.meterShownResult.splice(2, 0, accelerationData);
                }
                if (accelerationData.key !== 'RMS_Accel_1_X_Axis'
                  && accelerationData.key !== 'RMS_Accel_1_Y_Axis'
                  && accelerationData.key !== 'RMS_Accel_1_Z_Axis'
                  && accelerationData.key !== 'Rate of change of orientation'
                  && accelerationData.key !== 'Pitch'
                  && accelerationData.key !== 'Roll'
                  && accelerationData.key !== 'Yaw'
                  && accelerationData.key !== 'Bearing_Temperature'
                  && accelerationData.key !== 'Winding_Temperature'
                  && accelerationData.key !== 'Ambient_Temperature'
                  && accelerationData.key !== 'Rate of change of useful life left') {
                  this.meterShownResult.push(accelerationData);
                }
                if (accelerationData.key === 'Bearing_Temperature'
                  || accelerationData.key === 'Winding_Temperature'
                  || accelerationData.key === 'Ambient_Temperature') {
                  this.tempratueResults.push(accelerationData);

                }
                if (accelerationData.key === 'Rate of change of useful life left') {
                  this.rateOfChange.push(accelerationData);
                }

                if (accelerationData.key === 'Pitch') {
                  this._orientationX = accelerationData.needleValue;
                }
                if (accelerationData.key === 'Roll') {
                  this._orientationY = accelerationData.needleValue;
                }
                if (accelerationData.key === 'Yaw') {
                  this._orientationZ = accelerationData.needleValue;
                }
              }
            }
          }
        }
      }
    });
  }


  async goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : ''
      }
    };
    this.router.navigate([name], navigationExtras);
  }



  ngOnInit() {
    localStorage.setItem('dataInterval', null);
    this.siteName = localStorage.getItem('siteName');
    this.appMacAdd = localStorage.getItem('appMacAdd');
    this.serialNumber = localStorage.getItem('serialNumber');
    this.applicationNme = localStorage.getItem('applicationName');
    this.getGaugeDataByID();
    this.getFftList();
  }

  ngOnDestroy() {
    if (this._timeOut !== undefined) {
      clearInterval(this._timeOut);
    }
  }


  async getSensorCharts(_satus) {
    const SesnsorMaxVals = [];
    if (_satus !== "interval") {
      this.showlineChart1 = false;
    }
    let response: any;

    const body = {
      deviceid: parseInt(this.deviceId),
      assetid: parseInt(this.assetId),
      sensorinterval: this.selectValue === null ? 24 : this.selectValue,
      sensordetailtype: this.valueType,
      sensorids: [6, 7, 8],
      timezone: localStorage.getItem('clientTimeZone')
    };
    this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.assetId) + "/" + [6, 7, 8] + "/" + this.valueType).then(res => {
      this.chartBoxVisibility = true;
      response = JSON.parse(JSON.stringify(res)).data;
      if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === 'success') {
        if (response.body.chartdata === null) {
          // this._status = response.body.status;
          // this._offlineStatus = response.body.offlinestatus;
          // if (this._status === 'Offline') {
          //   this._devStaus = 'Last';
          // } else {
          //   this._devStaus = 'Latest';
          // }
          this.showlineChart1 = false;
        } else {
          let thresholdVals = [];
          thresholdVals = response.body.threshold;
          const xArrVal = [];
          if (response.body.chartdata !== 0) {
            this.showlineChart1 = true;
            let newArray = response.body.chartdata.map((currentValue) => {
              if (currentValue[0] !== "time") {
                currentValue[0] = new Date(currentValue[0]);
                return currentValue;
              }
              else {
                return currentValue;
              }
            });
            let minData = newArray[1][0];
            let maxData = newArray[newArray.length - 1][0];
            let dash_container = document.getElementById('dashboard_div');
            let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
            let data: any = google.visualization.arrayToDataTable(newArray);
            var formatter = new google.visualization.NumberFormat({ suffix: ' m/sec<sup>2</sup>' });

            formatter.format(data, 1);
            formatter.format(data, 2);
            formatter.format(data, 3);


            let options = {
              legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
              chartArea: { left: '2%', width: '100%' },
              height: 400,
              displayAnnotations: true,
              displayZoomButtons: false,
              displayLegendValues: true,
              responsive: true,
              vAxis: {
                format: 0,
                viewWindow: {
                  min: response.body.min,
                  max: response.body.max
                },
                gridlines: { color: 'transparent' }
              },
              hAxis: { gridlines: { color: 'transparent' } },
              isStacked: true,
              series: {
                0: { color: 'blue' },
                1: { color: 'yellow' },
                2: { color: '#dc3912' },
                3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
              },
              seriesType: 'line',
              trendlines: {
                0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '1' },
                1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '2' },
                2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '3' }
              }
            };

            let container = document.getElementById('chart_div');
            let myLine = new google.visualization.ChartWrapper({
              'chartType': 'ComboChart',
              'containerId': 'chart_div',
              'options': options,
              'view': {},
            });
            let myDateSlider = new (<any>google.visualization).ControlWrapper({
              'controlType': 'ChartRangeFilter',
              'containerId': 'control_div',
              'options': {
                'filterColumnIndex': 0,
                'ui': {
                  chartOptions: {
                    chartArea: {
                      left: '2%',
                      width: '97%'
                    },
                    series: {
                      0: { color: 'blue' },
                      1: { color: 'yellow' },
                      2: { color: '#dc3912' }
                    }
                  }
                }
              },
              'state': {
                range: {
                  start: this._sliderStart !== undefined ? this._sliderStart : minData,
                  end: this._sliderEnd !== undefined ? this._sliderEnd : maxData
                }

              },
            });

            google.visualization.events.addListener(myLine, 'ready', function () {
              var pathElements = container.getElementsByTagName('path');
              Array.prototype.forEach.call(pathElements, function (path) {
                if (path.getAttribute('stroke') === options.trendlines[0].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                }
              });
            });
            myDashboard.bind([myDateSlider], myLine);
            myDashboard.draw(data, options);
            var columns = [];
            var series = {};
            for (var i = 0; i < data.getNumberOfColumns(); i++) {
              columns.push(i);
              if (i > 0) {
                series[i - 1] = {};
              }
            }

            google.visualization.events.addListener(myLine, 'select', function () {
              let sel = myDashboard.getSelection();
              // if selection length is 0, we deselected an element
              if (sel.length > 0) {
                // if row is undefined, we clicked on the legend
                if (sel[0].row === null) {

                  var col = sel[0].column;
                  if (columns[col] == col) {
                    // hide the data series
                    columns[col] = {
                      label: data.getColumnLabel(col),
                      type: data.getColumnType(col),
                      calc: function () {
                        return null;
                      }
                    };

                    // grey out the legend entry
                    series[col - 1].color = '#CCCCCC';
                  }
                  else {
                    // show the data series
                    columns[col] = col;
                    series[col - 1].color = null;
                  }

                  let seriesOpt = {
                    0: { color: 'blue' },
                    1: { color: 'yellow' },
                    2: { color: '#dc3912' },
                    3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                    4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                    5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
                  };
                  var seriesOld = (<any>myLine.getOptions()).series;
                  for (var key in seriesOld) {
                    series[key] = seriesOld[key];
                    if (series[key].color == null) {
                      series[key].color = seriesOpt[key].color;
                    }
                  }
                  // set series option
                  myLine.setOption('series', series);
                  var view = new google.visualization.DataView(data);
                  view.setColumns(columns);
                  myDashboard.bind(myDateSlider, myLine);
                  myDashboard.draw(view, options);
                }
              }
            });
            var self = this;
            google.visualization.events.addListener(myDateSlider, 'statechange', function (e) {
              let stateDate = myDateSlider.getState();
              self._sliderStart = stateDate.range.start;
              self._sliderEnd = stateDate.range.end;

            });
          }
        }

      }
    });
  }


  getFftList() {
    this._spectralLoader = false;
    let self = this;
    let response: any;
    const body = {
      deviceid: this.deviceId,
      assetid: this.assetId
    };

    this.service.getDataWithQuery(this.Fft_List + "/" + this.deviceId + "/" + this.assetId).then(res => {
      this.loader = false;
      this.chartBoxVisibility = true;
      response = JSON.parse(JSON.stringify(res)).data;
      if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === 'success') {
        var newArr = response.body.map(function (val, index) {
          var ffttestDateUtc = moment.utc(val.fft_time);
          var localDatefft = ffttestDateUtc.local();
          let fftTIME = new ConvertDatetimePipe().convertDateTime(localDatefft);
          return { key: index, label: val.label + '' + fftTIME, fft_time: val.fft_time, line_freq: val.line_freq, rated_rpm: val.rated_rpm, actual_rpm: val.actual_rpm, value: val.value };
        })
        this.trendAnalysData = newArr;
      }
    });
  }

  ForcedSpectralAnalysis() {
    this._spectralLoader = true;
    let response: any;
    document.getElementById('spectralBtn').style.pointerEvents = 'none';
    const body = {
      deviceid: this.deviceId,
      assetid: this.assetId,
      api_type: "fft_force"
    };
    this.service.getDataWithQuery(this.Fft_Force + "/" + this.deviceId + "/" + this.assetId).then(res => {
      document.getElementById('spectralBtn').style.pointerEvents = 'auto';
      response = JSON.parse(JSON.stringify(res)).data;
      if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === 'success') {
        this._spectralLoader = false;
      }
    });
  }

  loadFftData(value) {
    let _timeFft = this.trendAnalysData.filter(v => v.value === parseInt(value))[0].label;
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        fftTime: value,
        fftDataTime: _timeFft,
        nameDevice: this.nameDevice,
        errorStatus: this.errorStatus,
        deviceStatus: this.deviceStatus,
        deviceID: this.deviceId,
        assetid: this.assetId,
        onOffStatus: this._status,
        deviceCurrentStatus: this._devStaus,
        sinceDate: this._offlineStatus,
        lastUpdate: this._lastUpdate
      }
    };
    this.router.navigate(['deep-link-detail/'], navigationExtras);
  }


  async getSensorTempCharts(_satus) {
    const sensorTempMaxVals = [];
    if (_satus !== "interval") {
      this.showlineChart2 = false;
    }
    let response: any;
    const body = {
      deviceid: this.deviceId,
      assetid: parseInt(this.assetId),
      sensorinterval: this.selectValue === null ? 24 : this.selectValue,
      sensordetailtype: this.valueType,
      sensorids: [1, 2, 3],
      timezone: localStorage.getItem('clientTimeZone')
      // tslint:disable-next-line: radix
      //datafrequency: parseInt(localStorage.getItem('dataFrq'))
    };
    this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.assetId) + "/" + [1, 2, 3] + "/" + this.valueType).then(res => {
      //this.showlineChart2 = true;
      this.chartBoxVisibility = true;
      response = JSON.parse(JSON.stringify(res)).data;
      if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === 'success') {
        if (response.body.chartdata === null) {
          this.showlineChart2 = false;
        } else {
          let thresholdVals = [];
          thresholdVals = response.body.threshold;
          if (response.body.chartdata !== 0) {
            this.showlineChart2 = true;
            let newArray = response.body.chartdata.map((currentValue) => {
              if (currentValue[0] !== "time") {
                currentValue[0] = new Date(currentValue[0]);
                return currentValue;
              }
              else {
                return currentValue;
              }
            });
            let minData = newArray[1][0];
            let maxData = newArray[newArray.length - 1][0];
            let dash_container = document.getElementById('dashboard_div_temp');
            let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
            let data: any = google.visualization.arrayToDataTable(newArray);
            var formatter = new google.visualization.NumberFormat({ suffix: ' C' });
            formatter.format(data, 1);
            formatter.format(data, 2);
            formatter.format(data, 3);
            let options = {
              legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
              chartArea: { left: '2%', width: '100%' },
              height: 400,
              displayAnnotations: true,
              displayZoomButtons: false,
              displayLegendValues: true,
              responsive: true,
              vAxis: {
                format: 0,
                viewWindow: {
                  min: response.body.min,
                  max: response.body.max
                },
                gridlines: { color: 'transparent' }
              },
              hAxis: { gridlines: { color: 'transparent' } },
              isStacked: true,
              series: {
                0: { color: 'blue' },
                1: { color: 'yellow' },
                2: { color: '#dc3912' },
                3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
              },
              seriesType: 'line',
              trendlines: {
                0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.5, id: '1' },
                1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.5, id: '2' },
                2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.5, id: '3' }
              }
            };

            let container = document.getElementById('chart_div_temp');
            let myLine = new google.visualization.ChartWrapper({
              'chartType': 'ComboChart',
              'containerId': 'chart_div_temp',
              'options': options,
              'view': {}
            });
            let myDateSlider = new (<any>google.visualization).ControlWrapper({
              'controlType': 'ChartRangeFilter',
              'containerId': 'control_div_temp',
              'options': {
                'filterColumnIndex': 0,
                'ui': {
                  chartOptions: {
                    chartArea: {
                      left: '2%',
                      width: '97%'
                    },
                    series: {
                      0: { color: 'blue' },
                      1: { color: 'yellow' },
                      2: { color: '#dc3912' }
                    }
                  }
                }
              },
              'state': {
                range: {
                  start: this._sliderStartTmp !== undefined ? this._sliderStartTmp : minData,
                  end: this._sliderEndTmp !== undefined ? this._sliderEndTmp : maxData
                }
              },
            });

            google.visualization.events.addListener(myLine, 'ready', function () {
              //myDashboard.draw(data, options);
              var pathElements = container.getElementsByTagName('path');
              Array.prototype.forEach.call(pathElements, function (path) {
                if (path.getAttribute('stroke') === options.trendlines[0].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                }
              });
            });

            myDashboard.bind([myDateSlider], myLine);
            myDashboard.draw(data, options);

            var columns = [];
            var series = {};
            for (var i = 0; i < data.getNumberOfColumns(); i++) {
              columns.push(i);
              if (i > 0) {
                series[i - 1] = {};
              }
            }

            google.visualization.events.addListener(myLine, 'select', function () {
              let sel = myDashboard.getSelection();
              // if selection length is 0, we deselected an element
              if (sel.length > 0) {
                // if row is undefined, we clicked on the legend
                if (sel[0].row === null) {

                  var col = sel[0].column;
                  if (columns[col] == col) {
                    // hide the data series
                    columns[col] = {
                      label: data.getColumnLabel(col),
                      type: data.getColumnType(col),
                      calc: function () {
                        return null;
                      }
                    };

                    // grey out the legend entry
                    series[col - 1].color = '#CCCCCC';
                  }
                  else {
                    // show the data series
                    columns[col] = col;
                    series[col - 1].color = null;
                  }
                  let seriesOpt = {
                    0: { color: 'blue' },
                    1: { color: 'yellow' },
                    2: { color: '#dc3912' },
                    3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                    4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                    5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
                  };
                  var seriesOld = (<any>myLine.getOptions()).series;
                  for (var key in seriesOld) {
                    series[key] = seriesOld[key];
                    if (series[key].color == null) {
                      series[key].color = seriesOpt[key].color;
                    }
                  }
                  // set series option
                  myLine.setOption('series', series);

                  var view = new google.visualization.DataView(data);
                  view.setColumns(columns);
                  myDashboard.bind(myDateSlider, myLine);
                  myDashboard.draw(view, options);
                }
              }
            });

            var self = this;
            google.visualization.events.addListener(myDateSlider, 'statechange', function (e) {
              let stateDate = myDateSlider.getState();
              self._sliderStartTmp = stateDate.range.start;
              self._sliderEndTmp = stateDate.range.end;

            });
          }

        }
      }
    });
  }

  async getSensorOrientationCharts(_satus) {
    const sensorOrMaxVals1 = [];
    const sensorOrMinVals1 = [];
    if (_satus !== "interval") {
      this.showlineChart3 = false;
    }
    let response: any;
    const body = {
      deviceid: this.deviceId,
      assetid: parseInt(this.assetId),
      sensorinterval: this.selectValue === null ? 24 : this.selectValue,
      sensordetailtype: this.valueType,
      sensorids: [25, 26, 27],
      timezone: localStorage.getItem('clientTimeZone')
      // tslint:disable-next-line: radix
      //datafrequency: parseInt(localStorage.getItem('dataFrq'))
    };
    this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.assetId) + "/" + [25, 26, 27] + "/" + this.valueType).then(res => {
      //this.showlineChart3 = true;
      this.chartBoxVisibility1 = true;
      response = JSON.parse(JSON.stringify(res)).data;
      if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === 'success') {
        if (response.body.chartdata === null) {
          this.showlineChart3 = false;
        } else {
          let thresholdVals = [];
          thresholdVals = response.body.threshold;
          const orArrVal = [];
          if (response.body.chartdata !== 0) {
            this.showlineChart3 = true;
            let newArray = response.body.chartdata.map((currentValue) => {
              if (currentValue[0] !== "time") {
                currentValue[0] = new Date(currentValue[0]);
                return currentValue;
              }
              else {
                return currentValue;
              }
            });

            let dash_container = document.getElementById('dashboard_div_orientation');
            let myDashboard = new (<any>google.visualization).Dashboard(dash_container);

            let data: any = google.visualization.arrayToDataTable(newArray);
            var formatter = new google.visualization.NumberFormat({ suffix: ' Degrees' });
            formatter.format(data, 1);
            formatter.format(data, 2);
            formatter.format(data, 3);

            let options = {
              legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
              chartArea: { left: '2%', width: '100%' },
              height: 400,
              displayAnnotations: true,
              displayZoomButtons: false,
              displayLegendValues: true,
              responsive: true,
              vAxis: {
                format: 0,
                viewWindow: {
                  min: response.body.min,
                  max: response.body.max
                },
                gridlines: { color: 'transparent' }
              },
              hAxis: { gridlines: { color: 'transparent' } },
              isStacked: true,
              series: {
                0: { color: 'blue' },
                1: { color: 'yellow' },
                2: { color: '#dc3912' },
                3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
                5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
              },
              seriesType: 'line',
              trendlines: {
                0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.5, id: '1' },
                1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.5, id: '2' },
                2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.5, id: '3' }
              }
            };
            // function resize() {
            //      let chart = new google.visualization.LineChart(document.getElementById('chart_div_orientation'));
            //     chart.draw(data, options);
            // }
            // window.onload = resize();
            // window.onresize = resize;

            let container = document.getElementById('chart_div_orientation');
            let myLine = new google.visualization.ChartWrapper({
              'chartType': 'ComboChart',
              'containerId': 'chart_div_orientation',
              'options': options,
              'view': {},
            });
            let myDateSlider = new (<any>google.visualization).ControlWrapper({
              'controlType': 'ChartRangeFilter',
              'containerId': 'control_div_orientation',
              'options': {
                'filterColumnIndex': 0,
                'ui': {
                  chartOptions: {
                    chartArea: {
                      left: '2%',
                      width: '97%'
                    }
                  }
                }
              },
            });

            google.visualization.events.addListener(myLine, 'ready', function () {
              //myDashboard.draw(data, options);
              var pathElements = container.getElementsByTagName('path');
              Array.prototype.forEach.call(pathElements, function (path) {
                if (path.getAttribute('stroke') === options.trendlines[0].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
                  path.setAttribute('stroke-dasharray', '4, 4');
                }
              });
            });

            myDashboard.bind([myDateSlider], myLine);
            myDashboard.draw(data, options);

            var columns = [];
            var series = {};
            for (var i = 0; i < data.getNumberOfColumns(); i++) {
              columns.push(i);
              if (i > 0) {
                series[i - 1] = {};
              }
            }

            google.visualization.events.addListener(myLine, 'select', function () {
              let sel = myDashboard.getSelection();
              // if selection length is 0, we deselected an element
              if (sel.length > 0) {
                // if row is undefined, we clicked on the legend
                if (sel[0].row === null) {
                  var col = sel[0].column;
                  if (columns[col] == col) {
                    // hide the data series
                    columns[col] = {
                      label: data.getColumnLabel(col),
                      type: data.getColumnType(col),
                      calc: function () {
                        return null;
                      }
                    };

                    // grey out the legend entry
                    series[col - 1].color = '#CCCCCC';
                  }
                  else {
                    // show the data series
                    columns[col] = col;
                    series[col - 1].color = null;
                  }
                  var seriesOld = (<any>myLine.getOptions()).series;
                  for (var key in seriesOld) {
                    series[key] = seriesOld[key];
                  }
                  // set series option
                  myLine.setOption('series', series);

                  var view = new google.visualization.DataView(data);
                  view.setColumns(columns);
                  myDashboard.bind(myDateSlider, myLine);

                  myDashboard.draw(view, options);
                }
              }
            });
          }
        }
      }
    });
  }

  async openDeepDetail() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        nameDevice: this.nameDevice,
        errorStatus: this.errorStatus,
        deviceStatus: this.deviceStatus,
        deviceID: this.deviceId,
        assetid: this.assetId,
        onOffStatus: this._status,
        deviceCurrentStatus: this._devStaus,
        sinceDate: this._offlineStatus,
        lastUpdate: this._lastUpdate
      }
    };
    this.router.navigate(['deep-link-detail/'], navigationExtras);
  }
  pageReload() {
    this.loader = true;
    this.ngOnInit();
  }
}
